import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/course?${params}`);
  },
  getById(id) {
    return api.get(`/api/course/byid/${id}`);
  },
  update(id, data) {
    return api.put(`/api/course/${id}`, data);
  },
  create(data) {
    return api.post(`/api/course`, data);
  },
  delete(id) {
    return api.delete(`/api/course/${id}`);
  },
};
